module.exports = __webpack_public_path__ + "static/happeningsBGImage-b58080cc93b4ab1544514673ad8f2c92.png";